module.exports = __webpack_public_path__ + "img/footerMastercard.4633f774.png";